import { AddemployeebillingComponent } from './addemployeebilling/addemployeebilling.component';
import { ViewemployeebillingComponent } from './viewemployeebilling/viewemployeebilling.component';

export const EmployeeBillingRouting = [
    {path: 'Add-employee-billing', component: AddemployeebillingComponent},
    {path: 'View-employee-billing', component: ViewemployeebillingComponent},
];

export const EmployeeBillingRoutingBreadcrumbs = [
    { name: 'View',path:'/View-employee-billing' },
    { name: 'Add', path: '/Add-employee-billing' },

];